import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { Header } from '@/widgets/Header';

import { ConnectMqttProvider } from './providers/ConnectMqttProvider';
import { ContextProvider } from './providers/ContextProvider';
import { Router } from './route/router';
import { ThemeProvider } from './providers/ThemeProvider';

import '@gravity-ui/uikit/styles/styles.css';
import './App.css';
import './design.css';
import './ui-refresh.css';
import './editorial.css';
import './visibility.css';
import { Loader } from '@/widgets/Loader';

const RailwayPage = lazy(() => import('@/page/RailwayPage/RailwayPage'));

function App() {
    return (
        <ContextProvider>
            <ThemeProvider>
                <BrowserRouter>
                    <Routes>
                        <Route
                            path="/railway"
                            element={
                                <Suspense fallback={<Loader fullscreen />}>
                                    <RailwayPage />
                                </Suspense>
                            }
                        />
                        <Route
                            path="*"
                            element={
                                <ConnectMqttProvider>
                                    <div className="App editorial-app">
                                        <Header className="Header" />
                                        <main className="Content">
                                            <Router />
                                        </main>
                                    </div>
                                </ConnectMqttProvider>
                            }
                        />
                    </Routes>
                </BrowserRouter>
            </ThemeProvider>
        </ContextProvider>
    );
}

export default App;
